import * as yup from 'yup';

export const NAME_REGEX = /^[0-9A-Za-z\s\-.,/'"():;$&@!?%]+$/;

const itemSchema = yup
  .object()
  .shape({
    description: yup
      .string()
      .trim()
      .matches(NAME_REGEX, 'Items.descriptionInvalidFormat')
      .required('Items.descriptionRequired'),
    currency: yup.string().required('Items.currencyRequired'),
    naturalAmount: yup
      .number()
      .min(0.1, 'Items.naturalAmountInvalidValue')
      .typeError('Items.naturalAmountRequired')
      .required('Items.naturalAmountRequired'),
    qty: yup.number().min(1, 'Items.qtyInvalidValue').required('Items.qtyRequired'),
    hkhsCode: yup.string(),
    isIncludesFood: yup.boolean(),
    isIncludesBattery: yup.boolean(),
    countryOfManufacture: yup.string().trim().required('Items.countryOfManufactureRequired'),
    remarks: yup.string(),
  })
  .defined();

export default itemSchema;
